// JavaScript source code
/* eslint-disable */
import React from 'react';
import {
    TextField,
    Datagrid,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
} from 'react-admin';
import { EditToolbar } from '../layout/EditToolbar';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { SwList } from '../lib/SwList';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import {
    validateStaticDataWithCode,
    BaseFilter,
    ShowTitleByTitle,
} from './Scaffolding';

export const ModeOfStudyLabels = {
    pageTitle: 'Modes Of Study',
    Title: 'Description',
};

export const ModeOfStudyList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={ModeOfStudyLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="code" />
                    <TextField label={ModeOfStudyLabels.Title} source="Title" />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const ModeOfStudyCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm validate={validateStaticDataWithCode}>
            <TextInput label={ModeOfStudyLabels.Title} source="Title" />
            <TextInput source="code" />
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

export const ModeOfStudyEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit {...props} title={<ShowTitleByTitle />}>
                <SimpleForm
                    validate={validateStaticDataWithCode}
                    toolbar={<EditToolbar />}
                >
                    <TextInput source="id" disabled />
                    <TextInput label={ModeOfStudyLabels.Title} source="Title" />
                    <TextInput source="code" />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const ModeOfStudyShow = (props) => (
    <Show {...props} title={<ShowTitleByTitle />}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label={ModeOfStudyLabels.Title} source="Title" />
            <TextField source="code" />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
